import React from 'react'
import PropTypes from 'prop-types'
import FormInput from 'components/FormInput'
import {reduxForm, Field, reset} from 'redux-form'
import {
  editSiteInternalWhitelistRegexes
} from 'redux/modules/sites/actions'

export class AddDomainForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool
  }

  render() {
    const {handleSubmit, invalid} = this.props

    return (
      <form
        className='settings-categories-view_add-form'
        onSubmit={handleSubmit}
      >
        <label htmlFor='regex'>Add new internal whitelist regex</label>
        <Field name='regex' component={FormInput} />
        <button type='submit' disabled={invalid}>
          Add
        </button>
      </form>
    )
  }
}

export default reduxForm({
  form: 'addRegexForm',
  validate: ({regex}, props) => {
    const {internalWhitelistRegexes = []} = props
    const errors = {}
    if (!regex) {
      errors.regex = 'Regex is required'
    }

    if (internalWhitelistRegexes?.includes(regex)) {
      errors.regex = 'Regex is exists'
    }

    return errors
  },
  onSubmit: ({regex}, dispatch, props) => {
    const {siteId, internalWhitelistRegexes = []} = props
    dispatch(
      editSiteInternalWhitelistRegexes({
        id: siteId,
        internalWhitelistRegexes: [...internalWhitelistRegexes, regex]
      })
    )
    dispatch(reset('addRegexForm'))
  }
})(AddDomainForm)



// WEBPACK FOOTER //
// ./client/views/SettingsDomainView/AddDomainForm.js